function loadMoreResults() {
  return window.addEventListener('load', (function () {
    $('.ais-InfiniteHits-loadMore').css({ 'visibility': 'visible' });
    return $('.platform-wrap > .content').scroll(function () {
      if (($('.ais-InfiniteHits-list').height() - $('.platform-wrap > .content').scrollTop()) < 600) {
        const loadMoreButton = document.querySelector('.ais-InfiniteHits-loadMore');
        if (loadMoreButton) {
          return loadMoreButton.click();
        }
      }
    });
  })
  );
}

module.exports = { loadMoreResults }
